<template>
  <two-factor-screen :button-action="add2fa" button-title="להוספת אמצעי הזדהות" :back-enabled="true">
    <template v-slot:text>
      <span class="title r-typo-headline">
        היי {{ currentMember.firstNamePiiValue }},
        מהיום התזרים שלך יהיה מוגן אפילו יותר!
      </span>
      <span class="text">
        בשלב הבא נוסיף לך
          <span class="bold">אמצעי הזדהות נוסף</span>
          שישמש אותך בכניסות הבאות לשירות.
        </span>
    </template>
  </two-factor-screen>
</template>

<script>

import DDLogs from '@/DDLogs';
import TwoFactorScreen from './2faLoginScreen';
import Segment from '../../../../Segment';
import CustomersApi from '../../../../api/CustomersApi';

export default {
  name: 'TwoFactorMigration',
  components: {
    TwoFactorScreen,
  },
  data() {
    return {
      currentMember: {},
    };
  },
  async created() {
    this.currentMember = await CustomersApi.getPartiallyAuthenticatedMember();
    if ((this.currentMember).hasOidc) {
      const { redirectTo } = this.$route.query;
      Segment.trackUserGot('GotTo@faMigrationPageWithOIDC', { redirectTo });
      DDLogs.log('The customer has Oids -> redirect to sr');
      window.location.href = `/${redirectTo || 'sr'}`;
    }
    Segment.trackUserGot('2faForcedMigrationEntered');
    DDLogs.log('The customer hasn\'t an Oidc -> redirect to Forced Migration');
  },
  methods: {

    add2fa() {
      Segment.trackUserInteraction('2faAdd2faClicked');
      DDLogs.log('Customer clicked Add2faClicked');
      window.location.href = '/api/partial-auth/login-with-auth0/migration';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../../scss/mixins';

.two-factor-login {

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;

  .title {
    padding: 15px 0;
  }

  .text {
    font-size: 18px;
    line-height: 26px;

    .bold {
      font-weight: bold;
    }
  }
}
</style>
